/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_PROVINCE,
    REQUEST_PROVINCE_FAILURE,
    REQUEST_PROVINCE_SUCCESS
} from "../../constant/postal-code/PostalCodeConstant";

const initialState = {
    province: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const provinceReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_PROVINCE:
            return {
                ...state,
                province: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_PROVINCE_SUCCESS:
            return {
                ...state,
                province: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_PROVINCE_FAILURE:
            return {
                ...state,
                province: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
